import React from 'react'
import technicianIcon from '../../../assets/svg/acompanhar-tecnico.svg'

const Technician = ({ color }) => (
  <div>
    <img src={technicianIcon} alt="Technician" />
  </div>
)

export default Technician



// WEBPACK FOOTER //
// ./src/components/TechnicianModal/components/Technician.js